import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
const endpoints = ((baseURL) => {
  return {
    //  GetMessageTotalCounters
    getMessageTotalCounters: (idList, idMessage, types, from, to) => `${baseURL}/api/report/lists/${encodeURIComponent(idList)}/messages/${encodeURIComponent(idMessage)}/totalcounters?${encodeParams({ types, from, to })}`
  }
})(process.env.STATS_URL)

//  getAllMessages: (idList, filterBy, orderBy, pageNum, pageSize) => (`${baseURL}/list/${encodeURIComponent(idList)}?${encodeParams({ filterBy, orderBy, pageNum, pageSize })}`)

export const statisticsApiGetMessageTotalCounters = (idList, idMessage, types, from, to) => {
  const url = endpoints.getMessageTotalCounters(idList, idMessage, types, from, to)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}
